import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  styled,
  useTheme,
  alpha
} from '@mui/material';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  margin: theme.spacing(4, 0),
  background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${alpha(theme.palette.primary.light, 0.05)} 100%)`,
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: `0 4px 20px ${alpha(theme.palette.primary.main, 0.1)}`,
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  marginBottom: theme.spacing(2),
  background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
}));

const PrivacyPolicy = () => {
  const theme = useTheme();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography
        variant="h3"
        component="h1"
        sx={{
          fontWeight: 700,
          textAlign: 'center',
          mb: 4,
          background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          color: 'transparent',
        }}
      >
        Privacy Policy
      </Typography>

      <StyledPaper>
        <SectionTitle variant="h5">1. Introduction</SectionTitle>
        <Typography variant="body1" paragraph>
          At Chaudhary's Life, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our family tree application.
        </Typography>

        <SectionTitle variant="h5">2. Information We Collect</SectionTitle>
        <Typography variant="body1" paragraph>
          We collect information that you provide directly to us, including:
        </Typography>
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1" paragraph>
            Personal information (name, email, phone number)
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Family tree data and relationships
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Photos and media content
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Communication preferences
          </Typography>
        </Box>

        <SectionTitle variant="h5">3. How We Use Your Information</SectionTitle>
        <Typography variant="body1" paragraph>
          We use the collected information to:
        </Typography>
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1" paragraph>
            Provide and maintain our services
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Improve user experience
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Communicate with you about updates and changes
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Ensure the security of our platform
          </Typography>
        </Box>

        <SectionTitle variant="h5">4. Data Security</SectionTitle>
        <Typography variant="body1" paragraph>
          We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
        </Typography>

        <SectionTitle variant="h5">5. Your Rights</SectionTitle>
        <Typography variant="body1" paragraph>
          You have the right to:
        </Typography>
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1" paragraph>
            Access your personal information
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Correct inaccurate data
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Request deletion of your data
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Opt-out of marketing communications
          </Typography>
        </Box>

        <SectionTitle variant="h5">6. Contact Us</SectionTitle>
        <Typography variant="body1" paragraph>
          If you have any questions about this Privacy Policy, please contact us at:
        </Typography>
        <Typography variant="body1" paragraph>
          Email: privacy@chaudharylife.com
        </Typography>
        <Typography variant="body1">
          Last updated: {new Date().toLocaleDateString()}
        </Typography>
      </StyledPaper>
    </Container>
  );
};

export default PrivacyPolicy; 